
// src/components/admin/page-management/section-forms/ContactFormSectionForm.js
import React, { useState,useEffect } from 'react';

const ContactFormSectionForm = ({ content, updateContent, section, pageId }) => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [showFieldsConfig, setShowFieldsConfig] = useState(false);
  const [showLayoutOptions, setShowLayoutOptions] = useState(false);

  const [sectionId, setSectionId] = useState(null);

  // On component mount, try to get section ID if available
  useEffect(() => {
    if (section && section._id) {
      setSectionId(section._id);
    }
  }, [section]);


  // Helper to update nested contact info
  const updateContactInfo = (field, value) => {
    // Get existing contactInfo or create default structure
    const existingContactInfo = content?.contactInfo || {
      phone: process.env.REACT_APP_COMPANY_PHONE_NUMBER || "+1 (833) 333-3101",
      email: process.env.REACT_APP_COMPANY_EMAIL || "Info@bagbox.ca",
      address: process.env.REACT_APP_COMPANY_ADDRESS || "102-1127 14th St W, North Vancouver, BC, V7P 1J9",
      hours: {
        weekday: "Monday - Friday: 9 AM - 5 PM",
        weekend: "Saturday - Sunday: Closed"
      },
      socialMedia: {
        facebook: "",
        twitter: "",
        instagram: "",
        linkedin: ""
      }
    };
    
    // Create a deep copy to avoid modifying the original object
    const newContactInfo = JSON.parse(JSON.stringify(existingContactInfo));
    
    if (field.includes('.')) {
      // Handle nested field like 'hours.weekday' or 'socialMedia.facebook'
      const [parent, child] = field.split('.');
      
      // Ensure the parent object exists
      if (!newContactInfo[parent]) {
        newContactInfo[parent] = {};
      }
      
      newContactInfo[parent][child] = value;
    } else {
      // Handle top-level field
      newContactInfo[field] = value;
    }
    
    // Update the content with the modified contactInfo
    updateContent('contactInfo', newContactInfo);
  };
  

  const getFormFields = () => {
    // If content already has formFields and it's an array with entries, use those
    if (content?.formFields && Array.isArray(content.formFields) && content.formFields.length > 0) {
      return content.formFields;
    }
    
    // Otherwise return default fields
    return defaultFormFields;
  };
  
  // Helper to update form fields
  const updateFormField = (index, property, value) => {
    // Get existing formFields or use default
    const formFields = Array.isArray(content?.formFields) ? 
      [...content.formFields] : 
      [...defaultFormFields];
    
    // Update the field
    formFields[index] = {
      ...formFields[index],
      [property]: value
    };
    
    // Simply use the existing updateContent function with non-stringified array
    updateContent('formFields', formFields);
  };

// Add new form field
const addFormField = () => {
  // Get existing formFields - ensure we're always working with a copy
  const formFields = Array.isArray(content?.formFields) ? 
    [...content.formFields] : 
    [...defaultFormFields];
  
  // Add a new field with unique ID
  const newField = {
    id: `field_${Date.now()}`,
    type: 'text',
    label: 'New Field',
    placeholder: 'Enter value',
    required: false,
    width: 'full'
  };
  
  // Add to array
  formFields.push(newField);
  
  console.log('Adding new field, updated formFields:', formFields);
  
  // Update the content with the new fields array
  updateContent('formFields', formFields);
};

// Remove form field
const removeFormField = (index) => {
  // Get existing formFields or use default
  const formFields = Array.isArray(content?.formFields) ? 
    [...content.formFields] : 
    [...defaultFormFields];
  
  // Remove the field at the specified index
  const updatedFields = formFields.filter((_, i) => i !== index);
  
  // Update the content with the modified fields
  updateContent('formFields', updatedFields);
};

// Move form field up/down
const moveFormField = (index, direction) => {
  // Get existing formFields or use default
  const formFields = Array.isArray(content?.formFields) ? 
    [...content.formFields] : 
    [...defaultFormFields];
  
  // Create a copy of the array
  const updatedFields = [...formFields];
  
  // Move field up or down
  if (direction === 'up' && index > 0) {
    [updatedFields[index], updatedFields[index - 1]] = 
    [updatedFields[index - 1], updatedFields[index]];
  } else if (direction === 'down' && index < updatedFields.length - 1) {
    [updatedFields[index], updatedFields[index + 1]] = 
    [updatedFields[index + 1], updatedFields[index]];
  }
  
  // Update the content with the reordered fields
  updateContent('formFields', updatedFields);
};

 
  // Default form fields if not defined
  const defaultFormFields = [
    {
      id: 'name',
      type: 'text',
      label: 'Your Name',
      placeholder: 'Your Name',
      required: true,
      width: 'half'
    },
    {
      id: 'email',
      type: 'email',
      label: 'Your Email',
      placeholder: 'Your Email',
      required: true,
      width: 'half'
    },
    {
      id: 'phone',
      type: 'tel',
      label: 'Phone Number',
      placeholder: 'Phone Number (Optional)',
      required: false,
      width: 'half'
    },
    {
      id: 'company',
      type: 'text',
      label: 'Company Name',
      placeholder: 'Company Name (Optional)',
      required: false,
      width: 'half'
    },
    {
      id: 'message',
      type: 'textarea',
      label: 'Your Message',
      placeholder: 'Your Message',
      required: true,
      width: 'full'
    }
  ];

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Contact Form Configuration</h3>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Form Section Title
        </label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          value={content?.title || 'Send Us a Message'}
          onChange={(e) => updateContent('title', e.target.value)}
          placeholder="Send Us a Message"
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Form Submit Button Text
        </label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          value={content?.submitButtonText || 'Send Message'}
          onChange={(e) => updateContent('submitButtonText', e.target.value)}
          placeholder="Send Message"
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Success Message
        </label>
        <textarea
          className="w-full p-2 border rounded"
          value={content?.successMessage || "Thank you for your message! We'll get back to you soon."}
          onChange={(e) => updateContent('successMessage', e.target.value)}
          placeholder="Thank you for your message! We'll get back to you soon."
          rows="2"
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Error Message
        </label>
        <textarea
          className="w-full p-2 border rounded"
          value={content?.errorMessage || "Sorry, there was an error sending your message. Please try again."}
          onChange={(e) => updateContent('errorMessage', e.target.value)}
          placeholder="Sorry, there was an error sending your message. Please try again."
          rows="2"
        />
      </div>
      
      <div className="mb-4">
        <label className="flex items-center text-sm font-medium text-gray-700">
          <input
            type="checkbox"
            className="mr-2 h-4 w-4"
            checked={content?.showContactInfo !== false}
            onChange={(e) => updateContent('showContactInfo', e.target.checked)}
          />
          Show Contact Information Panel
        </label>
      </div>
      
      {content?.showContactInfo !== false && (
        <div className="border-t border-gray-200 pt-4 mb-4">
          <h4 className="font-medium text-gray-800 mb-3">Contact Information</h4>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone Number
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.contactInfo?.phone || process.env.REACT_APP_COMPANY_PHONE_NUMBER || '+1 (833) 333-3101'}
              onChange={(e) => updateContactInfo('phone', e.target.value)}
              placeholder="+1 (833) 333-3101"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email Address
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.contactInfo?.email || process.env.REACT_APP_COMPANY_EMAIL || 'Info@bagbox.ca'}
              onChange={(e) => updateContactInfo('email', e.target.value)}
              placeholder="Info@bagbox.ca"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Business Address
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.contactInfo?.address || process.env.REACT_APP_COMPANY_ADDRESS || '102-1127 14th St W, North Vancouver, BC, V7P 1J9'}
              onChange={(e) => updateContactInfo('address', e.target.value)}
              placeholder="102-1127 14th St W, North Vancouver, BC, V7P 1J9"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Weekday Hours
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.contactInfo?.hours?.weekday || 'Monday - Friday: 9 AM - 5 PM'}
              onChange={(e) => updateContactInfo('hours.weekday', e.target.value)}
              placeholder="Monday - Friday: 9 AM - 5 PM"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Weekend Hours
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.contactInfo?.hours?.weekend || 'Saturday - Sunday: Closed'}
              onChange={(e) => updateContactInfo('hours.weekend', e.target.value)}
              placeholder="Saturday - Sunday: Closed"
            />
          </div>
          
          <h4 className="font-medium text-gray-800 mb-3 mt-4">Social Media (Optional)</h4>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Facebook URL
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.contactInfo?.socialMedia?.facebook || ''}
              onChange={(e) => updateContactInfo('socialMedia.facebook', e.target.value)}
              placeholder="https://facebook.com/yourcompany"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Twitter URL
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.contactInfo?.socialMedia?.twitter || ''}
              onChange={(e) => updateContactInfo('socialMedia.twitter', e.target.value)}
              placeholder="https://twitter.com/yourcompany"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Instagram URL
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.contactInfo?.socialMedia?.instagram || ''}
              onChange={(e) => updateContactInfo('socialMedia.instagram', e.target.value)}
              placeholder="https://instagram.com/yourcompany"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              LinkedIn URL
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.contactInfo?.socialMedia?.linkedin || ''}
              onChange={(e) => updateContactInfo('socialMedia.linkedin', e.target.value)}
              placeholder="https://linkedin.com/company/yourcompany"
            />
          </div>
        </div>
      )}
      
      {/* Form Fields Configuration */}
      <div className="border-t border-gray-200 pt-4">
        <button
          type="button"
          className="text-sm text-blue-600 hover:text-blue-800 mb-4"
          onClick={() => setShowFieldsConfig(!showFieldsConfig)}
        >
          {showFieldsConfig ? 'Hide Form Fields Configuration' : 'Show Form Fields Configuration'}
        </button>
        
        {showFieldsConfig && (
          <div className="space-y-4">
            <h4 className="font-medium text-gray-800 mb-3">Form Fields</h4>
            
            <div className="bg-gray-50 p-4 rounded">
              <p className="text-sm text-gray-700 mb-2">Configure the fields that appear in your contact form:</p>
              
              {getFormFields().map((field, index) => (
                <div key={field.id} className="border rounded-lg p-4 mb-4 bg-white">
                  <div className="flex justify-between items-center mb-3">
                    <h5 className="font-medium">{field.label || `Field ${index + 1}`}</h5>
                    <div className="flex space-x-2">
                      <button 
                        type="button"
                        onClick={() => moveFormField(index, 'up')}
                        disabled={index === 0}
                        className={`text-gray-500 ${index === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-700'}`}
                      >
                        ↑
                      </button>
                      <button 
                        type="button"
                        onClick={() => moveFormField(index, 'down')}
                        disabled={index === (content?.formFields || defaultFormFields).length - 1}
                        className={`text-gray-500 ${index === (content?.formFields || defaultFormFields).length - 1 ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-700'}`}
                      >
                        ↓
                      </button>
                      <button 
                        type="button"
                        onClick={() => removeFormField(index)}
                        className="text-red-500 hover:text-red-700"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Field Type
                      </label>
                      <select
                        className="w-full p-2 border rounded text-sm"
                        value={field.type}
                        onChange={(e) => updateFormField(index, 'type', e.target.value)}
                      >
                        <option value="text">Text</option>
                        <option value="email">Email</option>
                        <option value="tel">Phone</option>
                        <option value="textarea">Text Area</option>
                        <option value="select">Dropdown</option>
                        <option value="checkbox">Checkbox</option>
                      </select>
                    </div>
                    
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Field Width
                      </label>
                      <select
                        className="w-full p-2 border rounded text-sm"
                        value={field.width}
                        onChange={(e) => updateFormField(index, 'width', e.target.value)}
                      >
                        <option value="full">Full Width</option>
                        <option value="half">Half Width</option>
                        <option value="third">One Third</option>
                      </select>
                    </div>
                    
                    <div className="col-span-2">
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Label
                      </label>
                      <input
                        type="text"
                        className="w-full p-2 border rounded text-sm"
                        value={field.label}
                        onChange={(e) => updateFormField(index, 'label', e.target.value)}
                        placeholder="Field Label"
                      />
                    </div>
                    
                    <div className="col-span-2">
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Placeholder
                      </label>
                      <input
                        type="text"
                        className="w-full p-2 border rounded text-sm"
                        value={field.placeholder}
                        onChange={(e) => updateFormField(index, 'placeholder', e.target.value)}
                        placeholder="Field Placeholder"
                      />
                    </div>
                    
                    {field.type === 'select' && (
                      <div className="col-span-2">
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Options (comma separated)
                        </label>
                        <input
                          type="text"
                          className="w-full p-2 border rounded text-sm"
                          value={field.options || ''}
                          onChange={(e) => updateFormField(index, 'options', e.target.value)}
                          placeholder="Option 1, Option 2, Option 3"
                        />
                      </div>
                    )}
                    
                    <div className="col-span-2">
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          className="mr-2"
                          checked={field.required}
                          onChange={(e) => updateFormField(index, 'required', e.target.checked)}
                        />
                        <span className="text-sm">Required Field</span>
                      </label>
                    </div>
                  </div>
                </div>
              ))}
              
              <button
                type="button"
                onClick={addFormField}
                className="w-full py-2 mt-2 bg-blue-50 text-blue-600 rounded border border-blue-200 hover:bg-blue-100"
              >
                + Add New Field
              </button>
            </div>
          </div>
        )}
      </div>
      
      {/* Layout Options */}
      <div className="border-t border-gray-200 pt-4">
        <button
          type="button"
          className="text-sm text-blue-600 hover:text-blue-800 mb-4"
          onClick={() => setShowLayoutOptions(!showLayoutOptions)}
        >
          {showLayoutOptions ? 'Hide Layout Options' : 'Show Layout Options'}
        </button>
        
        {showLayoutOptions && (
          <div className="space-y-4">
            <h4 className="font-medium text-gray-800 mb-3">Layout Options</h4>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Layout Type
              </label>
              <select
                className="w-full p-2 border rounded"
                value={content?.layoutType || 'side-by-side'}
                onChange={(e) => updateContent('layoutType', e.target.value)}
              >
                <option value="side-by-side">Side by Side (Info | Form)</option>
                <option value="form-top">Form Above Info</option>
                <option value="info-top">Info Above Form</option>
                <option value="form-only">Form Only</option>
              </select>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Border Radius
              </label>
              <select
                className="w-full p-2 border rounded"
                value={content?.borderRadius || 'rounded-xl'}
                onChange={(e) => updateContent('borderRadius', e.target.value)}
              >
                <option value="rounded-none">None</option>
                <option value="rounded">Small</option>
                <option value="rounded-md">Medium</option>
                <option value="rounded-lg">Large</option>
                <option value="rounded-xl">Extra Large</option>
                <option value="rounded-full">Full/Pill</option>
              </select>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Shadow Style
              </label>
              <select
                className="w-full p-2 border rounded"
                value={content?.shadowStyle || 'shadow-xl'}
                onChange={(e) => updateContent('shadowStyle', e.target.value)}
              >
                <option value="shadow-none">None</option>
                <option value="shadow-sm">Small</option>
                <option value="shadow">Medium</option>
                <option value="shadow-md">Large</option>
                <option value="shadow-lg">Extra Large</option>
                <option value="shadow-xl">2XL</option>
              </select>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Padding
              </label>
              <select
                className="w-full p-2 border rounded"
                value={content?.padding || 'p-12'}
                onChange={(e) => updateContent('padding', e.target.value)}
              >
                <option value="p-4">Small (16px)</option>
                <option value="p-6">Medium (24px)</option>
                <option value="p-8">Large (32px)</option>
                <option value="p-12">Extra Large (48px)</option>
                <option value="p-16">2XL (64px)</option>
              </select>
            </div>
            
            <div className="mb-4">
              <label className="flex items-center text-sm font-medium text-gray-700">
                <input
                  type="checkbox"
                  className="mr-2 h-4 w-4"
                  checked={content?.showSocialIcons !== false}
                  onChange={(e) => updateContent('showSocialIcons', e.target.checked)}
                />
                Show Social Media Icons
              </label>
            </div>
            
            <div className="mb-4">
              <label className="flex items-center text-sm font-medium text-gray-700">
                <input
                  type="checkbox"
                  className="mr-2 h-4 w-4"
                  checked={content?.enableCaptcha === true}
                  onChange={(e) => updateContent('enableCaptcha', e.target.checked)}
                />
                Enable CAPTCHA Protection
              </label>
              {content?.enableCaptcha && (
                <p className="text-xs text-gray-500 mt-1 ml-6">
                  CAPTCHA will be enabled to protect against spam submissions.
                </p>
              )}
            </div>
          </div>
        )}
      </div>
      
      {/* Advanced Settings */}
      <div className="border-t border-gray-200 pt-4">
        <button
          type="button"
          className="text-sm text-blue-600 hover:text-blue-800 mb-4"
          onClick={() => setShowAdvanced(!showAdvanced)}
        >
          {showAdvanced ? 'Hide Advanced Style Options' : 'Show Advanced Style Options'}
        </button>
        
        {showAdvanced && (
          <div className="space-y-4">
            <h4 className="font-medium text-gray-800 mb-3">Style Customization</h4>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Info Panel Background Color
              </label>
              <div className="flex items-center">
                <input
                  type="color"
                  className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
                  value={content?.backgroundColor || '#1A4B84'}
                  onChange={(e) => updateContent('backgroundColor', e.target.value)}
                />
                <input
                  type="text"
                  className="flex-1 p-2 border rounded"
                  value={content?.backgroundColor || '#1A4B84'}
                  onChange={(e) => updateContent('backgroundColor', e.target.value)}
                  placeholder="#1A4B84"
                />
              </div>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Info Panel Text Color
              </label>
              <div className="flex items-center">
                <input
                  type="color"
                  className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
                  value={content?.textColor || '#ffffff'}
                  onChange={(e) => updateContent('textColor', e.target.value)}
                />
                <input
                  type="text"
                  className="flex-1 p-2 border rounded"
                  value={content?.textColor || '#ffffff'}
                  onChange={(e) => updateContent('textColor', e.target.value)}
                  placeholder="#ffffff"
                />
              </div>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Form Background Color
              </label>
              <div className="flex items-center">
                <input
                  type="color"
                  className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
                  value={content?.formBackgroundColor || '#ffffff'}
                  onChange={(e) => updateContent('formBackgroundColor', e.target.value)}
                />
                <input
                  type="text"
                  className="flex-1 p-2 border rounded"
                  value={content?.formBackgroundColor || '#ffffff'}
                  onChange={(e) => updateContent('formBackgroundColor', e.target.value)}
                  placeholder="#ffffff"
                />
              </div>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Button Background Color
              </label>
              <div className="flex items-center">
                <input
                  type="color"
                  className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
                  value={content?.buttonColor || '#1A4B84'}
                  onChange={(e) => updateContent('buttonColor', e.target.value)}
                />
                <input
                  type="text"
                  className="flex-1 p-2 border rounded"
                  value={content?.buttonColor || '#1A4B84'}
                  onChange={(e) => updateContent('buttonColor', e.target.value)}
                  placeholder="#1A4B84"
                />
              </div>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Button Text Color
              </label>
              <div className="flex items-center">
                <input
                  type="color"
                  className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
                  value={content?.buttonTextColor || '#ffffff'}
                  onChange={(e) => updateContent('buttonTextColor', e.target.value)}
                />
                <input
                  type="text"
                  className="flex-1 p-2 border rounded"
                  value={content?.buttonTextColor || '#ffffff'}
                  onChange={(e) => updateContent('buttonTextColor', e.target.value)}
                  placeholder="#ffffff"
                />
              </div>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Field Border Color
              </label>
              <div className="flex items-center">
                <input
                  type="color"
                  className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
                  value={content?.fieldBorderColor || '#e5e7eb'}
                  onChange={(e) => updateContent('fieldBorderColor', e.target.value)}
                />
                <input
                  type="text"
                  className="flex-1 p-2 border rounded"
                  value={content?.fieldBorderColor || '#e5e7eb'}
                  onChange={(e) => updateContent('fieldBorderColor', e.target.value)}
                  placeholder="#e5e7eb"
                />
              </div>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Form Field Border Radius
              </label>
              <select
                className="w-full p-2 border rounded"
                value={content?.fieldBorderRadius || 'rounded-lg'}
                onChange={(e) => updateContent('fieldBorderRadius', e.target.value)}
              >
                <option value="rounded-none">None</option>
                <option value="rounded">Small</option>
                <option value="rounded-md">Medium</option>
                <option value="rounded-lg">Large</option>
                <option value="rounded-xl">Extra Large</option>
              </select>
            </div>
            
            <div className="mb-4">
              <label className="flex items-center text-sm font-medium text-gray-700">
                <input
                  type="checkbox"
                  className="mr-2 h-4 w-4"
                  checked={content?.buttonFullWidth !== false}
                  onChange={(e) => updateContent('buttonFullWidth', e.target.checked)}
                />
                Full Width Submit Button
              </label>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Custom CSS (Advanced)
              </label>
              <textarea
                className="w-full p-2 border rounded font-mono text-sm"
                value={content?.customCss || ''}
                onChange={(e) => updateContent('customCss', e.target.value)}
                placeholder=".contact-form { /* custom styles */ }"
                rows="4"
              />
              <p className="text-xs text-gray-500 mt-1">
                Add custom CSS to further customize your form (for advanced users).
              </p>
            </div>
          </div>
        )}
      </div>
      
      <div className="bg-blue-50 p-4 rounded-md mb-6">
        <h4 className="text-blue-800 font-medium mb-2">Important Notes</h4>
        <ul className="text-sm text-blue-700 space-y-1 list-disc list-inside">
          <li>Form validation will automatically handle required fields</li>
          <li>All form submissions will be sent to your specified email</li>
          <li>Social media links will only appear if URLs are provided</li>
          {content?.enableCaptcha && (
            <li>CAPTCHA requires additional server-side configuration</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ContactFormSectionForm;




















// // src/components/admin/page-management/section-forms/ContactFormSectionForm.js
// import React, { useState } from 'react';

// const ContactFormSectionForm = ({ content, updateContent }) => {
//   const [showAdvanced, setShowAdvanced] = useState(false);
//   const [showFieldsConfig, setShowFieldsConfig] = useState(false);
//   const [showLayoutOptions, setShowLayoutOptions] = useState(false);

//   // Helper to update nested contact info
//   const updateContactInfo = (field, value) => {
//     // Get existing contactInfo or create default structure
//     const existingContactInfo = content?.contactInfo || {
//       phone: process.env.REACT_APP_COMPANY_PHONE_NUMBER || "+1 (833) 333-3101",
//       email: process.env.REACT_APP_COMPANY_EMAIL || "Info@bagbox.ca",
//       address: process.env.REACT_APP_COMPANY_ADDRESS || "102-1127 14th St W, North Vancouver, BC, V7P 1J9",
//       hours: {
//         weekday: "Monday - Friday: 9 AM - 5 PM",
//         weekend: "Saturday - Sunday: Closed"
//       },
//       socialMedia: {
//         facebook: "",
//         twitter: "",
//         instagram: "",
//         linkedin: ""
//       }
//     };
    
//     // Create a deep copy to avoid modifying the original object
//     const newContactInfo = JSON.parse(JSON.stringify(existingContactInfo));
    
//     if (field.includes('.')) {
//       // Handle nested field like 'hours.weekday' or 'socialMedia.facebook'
//       const [parent, child] = field.split('.');
      
//       // Ensure the parent object exists
//       if (!newContactInfo[parent]) {
//         newContactInfo[parent] = {};
//       }
      
//       newContactInfo[parent][child] = value;
//     } else {
//       // Handle top-level field
//       newContactInfo[field] = value;
//     }
    
//     // Update the content with the modified contactInfo
//     updateContent('contactInfo', newContactInfo);
//   };
  

//   const getFormFields = () => {
//     // If content already has formFields and it's an array with entries, use those
//     if (content?.formFields && Array.isArray(content.formFields) && content.formFields.length > 0) {
//       return content.formFields;
//     }
    
//     // Otherwise return default fields
//     return defaultFormFields;
//   };
  
//   // Helper to update form fields
//   const updateFormField = (index, property, value) => {
//     // Get existing formFields or use default
//     const formFields = Array.isArray(content?.formFields) ? 
//       JSON.parse(JSON.stringify(content.formFields)) : 
//       JSON.parse(JSON.stringify(defaultFormFields));
    
//     // Update the specific field
//     if (formFields[index]) {
//       formFields[index][property] = value;
//     }
    
//     console.log('Updating formFields with:', formFields);
    
//     // Update the content with the modified fields
//     updateContent('formFields', formFields);
//   };
  

//   // Move form field up/down
//   const moveFormField = (index, direction) => {
//     // Get existing formFields or use default
//     const formFields = Array.isArray(content?.formFields) ? 
//       [...content.formFields] : 
//       [...defaultFormFields];
    
//     // Create a copy of the array
//     const updatedFields = [...formFields];
    
//     // Move field up or down
//     if (direction === 'up' && index > 0) {
//       [updatedFields[index], updatedFields[index - 1]] = 
//       [updatedFields[index - 1], updatedFields[index]];
//     } else if (direction === 'down' && index < updatedFields.length - 1) {
//       [updatedFields[index], updatedFields[index + 1]] = 
//       [updatedFields[index + 1], updatedFields[index]];
//     }
    
//     // Update the content with the reordered fields
//     updateContent('formFields', updatedFields);
//   };

//   // Add new form field
//   const addFormField = () => {
//     // Get existing formFields - ensure we're always working with a copy
//     const formFields = Array.isArray(content?.formFields) ? 
//       JSON.parse(JSON.stringify(content.formFields)) : 
//       JSON.parse(JSON.stringify(defaultFormFields));
    
//     // Add a new field with unique ID
//     const newField = {
//       id: `field_${Date.now()}`,
//       type: 'text',
//       label: 'New Field',
//       placeholder: 'Enter value',
//       required: false,
//       width: 'full'
//     };
    
//     // Add to array
//     formFields.push(newField);
    
//     console.log('Adding new field, updated formFields:', formFields);
    
//     // Update the content with the new fields array
//     updateContent('formFields', formFields);
//   };
  

//   // Remove form field
//   const removeFormField = (index) => {
//     // Get existing formFields or use default
//     const formFields = Array.isArray(content?.formFields) ? 
//       [...content.formFields] : 
//       [...defaultFormFields];
    
//     // Remove the field at the specified index
//     const updatedFields = formFields.filter((_, i) => i !== index);
    
//     // Update the content with the modified fields
//     updateContent('formFields', updatedFields);
//   };
  

//   // Default form fields if not defined
//   const defaultFormFields = [
//     {
//       id: 'name',
//       type: 'text',
//       label: 'Your Name',
//       placeholder: 'Your Name',
//       required: true,
//       width: 'half'
//     },
//     {
//       id: 'email',
//       type: 'email',
//       label: 'Your Email',
//       placeholder: 'Your Email',
//       required: true,
//       width: 'half'
//     },
//     {
//       id: 'phone',
//       type: 'tel',
//       label: 'Phone Number',
//       placeholder: 'Phone Number (Optional)',
//       required: false,
//       width: 'half'
//     },
//     {
//       id: 'company',
//       type: 'text',
//       label: 'Company Name',
//       placeholder: 'Company Name (Optional)',
//       required: false,
//       width: 'half'
//     },
//     {
//       id: 'message',
//       type: 'textarea',
//       label: 'Your Message',
//       placeholder: 'Your Message',
//       required: true,
//       width: 'full'
//     }
//   ];

//   return (
//     <div className="space-y-4">
//       <h3 className="text-lg font-medium">Contact Form Configuration</h3>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Form Section Title
//         </label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           value={content?.title || 'Send Us a Message'}
//           onChange={(e) => updateContent('title', e.target.value)}
//           placeholder="Send Us a Message"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Form Submit Button Text
//         </label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           value={content?.submitButtonText || 'Send Message'}
//           onChange={(e) => updateContent('submitButtonText', e.target.value)}
//           placeholder="Send Message"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Success Message
//         </label>
//         <textarea
//           className="w-full p-2 border rounded"
//           value={content?.successMessage || "Thank you for your message! We'll get back to you soon."}
//           onChange={(e) => updateContent('successMessage', e.target.value)}
//           placeholder="Thank you for your message! We'll get back to you soon."
//           rows="2"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Error Message
//         </label>
//         <textarea
//           className="w-full p-2 border rounded"
//           value={content?.errorMessage || "Sorry, there was an error sending your message. Please try again."}
//           onChange={(e) => updateContent('errorMessage', e.target.value)}
//           placeholder="Sorry, there was an error sending your message. Please try again."
//           rows="2"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="flex items-center text-sm font-medium text-gray-700">
//           <input
//             type="checkbox"
//             className="mr-2 h-4 w-4"
//             checked={content?.showContactInfo !== false}
//             onChange={(e) => updateContent('showContactInfo', e.target.checked)}
//           />
//           Show Contact Information Panel
//         </label>
//       </div>
      
//       {content?.showContactInfo !== false && (
//         <div className="border-t border-gray-200 pt-4 mb-4">
//           <h4 className="font-medium text-gray-800 mb-3">Contact Information</h4>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Phone Number
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.phone || process.env.REACT_APP_COMPANY_PHONE_NUMBER || '+1 (833) 333-3101'}
//               onChange={(e) => updateContactInfo('phone', e.target.value)}
//               placeholder="+1 (833) 333-3101"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Email Address
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.email || process.env.REACT_APP_COMPANY_EMAIL || 'Info@bagbox.ca'}
//               onChange={(e) => updateContactInfo('email', e.target.value)}
//               placeholder="Info@bagbox.ca"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Business Address
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.address || process.env.REACT_APP_COMPANY_ADDRESS || '102-1127 14th St W, North Vancouver, BC, V7P 1J9'}
//               onChange={(e) => updateContactInfo('address', e.target.value)}
//               placeholder="102-1127 14th St W, North Vancouver, BC, V7P 1J9"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Weekday Hours
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.hours?.weekday || 'Monday - Friday: 9 AM - 5 PM'}
//               onChange={(e) => updateContactInfo('hours.weekday', e.target.value)}
//               placeholder="Monday - Friday: 9 AM - 5 PM"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Weekend Hours
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.hours?.weekend || 'Saturday - Sunday: Closed'}
//               onChange={(e) => updateContactInfo('hours.weekend', e.target.value)}
//               placeholder="Saturday - Sunday: Closed"
//             />
//           </div>
          
//           <h4 className="font-medium text-gray-800 mb-3 mt-4">Social Media (Optional)</h4>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Facebook URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.facebook || ''}
//               onChange={(e) => updateContactInfo('socialMedia.facebook', e.target.value)}
//               placeholder="https://facebook.com/yourcompany"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Twitter URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.twitter || ''}
//               onChange={(e) => updateContactInfo('socialMedia.twitter', e.target.value)}
//               placeholder="https://twitter.com/yourcompany"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Instagram URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.instagram || ''}
//               onChange={(e) => updateContactInfo('socialMedia.instagram', e.target.value)}
//               placeholder="https://instagram.com/yourcompany"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               LinkedIn URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.linkedin || ''}
//               onChange={(e) => updateContactInfo('socialMedia.linkedin', e.target.value)}
//               placeholder="https://linkedin.com/company/yourcompany"
//             />
//           </div>
//         </div>
//       )}
      
//       {/* Form Fields Configuration */}
//       <div className="border-t border-gray-200 pt-4">
//         <button
//           type="button"
//           className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//           onClick={() => setShowFieldsConfig(!showFieldsConfig)}
//         >
//           {showFieldsConfig ? 'Hide Form Fields Configuration' : 'Show Form Fields Configuration'}
//         </button>
        
//         {showFieldsConfig && (
//           <div className="space-y-4">
//             <h4 className="font-medium text-gray-800 mb-3">Form Fields</h4>
            
//             <div className="bg-gray-50 p-4 rounded">
//               <p className="text-sm text-gray-700 mb-2">Configure the fields that appear in your contact form:</p>
              
//               {getFormFields().map((field, index) => (
//                 <div key={field.id} className="border rounded-lg p-4 mb-4 bg-white">
//                   <div className="flex justify-between items-center mb-3">
//                     <h5 className="font-medium">{field.label || `Field ${index + 1}`}</h5>
//                     <div className="flex space-x-2">
//                       <button 
//                         type="button"
//                         onClick={() => moveFormField(index, 'up')}
//                         disabled={index === 0}
//                         className={`text-gray-500 ${index === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-700'}`}
//                       >
//                         ↑
//                       </button>
//                       <button 
//                         type="button"
//                         onClick={() => moveFormField(index, 'down')}
//                         disabled={index === (content?.formFields || defaultFormFields).length - 1}
//                         className={`text-gray-500 ${index === (content?.formFields || defaultFormFields).length - 1 ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-700'}`}
//                       >
//                         ↓
//                       </button>
//                       <button 
//                         type="button"
//                         onClick={() => removeFormField(index)}
//                         className="text-red-500 hover:text-red-700"
//                       >
//                         ×
//                       </button>
//                     </div>
//                   </div>
                  
//                   <div className="grid grid-cols-2 gap-3">
//                     <div>
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Field Type
//                       </label>
//                       <select
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.type}
//                         onChange={(e) => updateFormField(index, 'type', e.target.value)}
//                       >
//                         <option value="text">Text</option>
//                         <option value="email">Email</option>
//                         <option value="tel">Phone</option>
//                         <option value="textarea">Text Area</option>
//                         <option value="select">Dropdown</option>
//                         <option value="checkbox">Checkbox</option>
//                       </select>
//                     </div>
                    
//                     <div>
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Field Width
//                       </label>
//                       <select
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.width}
//                         onChange={(e) => updateFormField(index, 'width', e.target.value)}
//                       >
//                         <option value="full">Full Width</option>
//                         <option value="half">Half Width</option>
//                         <option value="third">One Third</option>
//                       </select>
//                     </div>
                    
//                     <div className="col-span-2">
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Label
//                       </label>
//                       <input
//                         type="text"
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.label}
//                         onChange={(e) => updateFormField(index, 'label', e.target.value)}
//                         placeholder="Field Label"
//                       />
//                     </div>
                    
//                     <div className="col-span-2">
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Placeholder
//                       </label>
//                       <input
//                         type="text"
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.placeholder}
//                         onChange={(e) => updateFormField(index, 'placeholder', e.target.value)}
//                         placeholder="Field Placeholder"
//                       />
//                     </div>
                    
//                     {field.type === 'select' && (
//                       <div className="col-span-2">
//                         <label className="block text-xs font-medium text-gray-700 mb-1">
//                           Options (comma separated)
//                         </label>
//                         <input
//                           type="text"
//                           className="w-full p-2 border rounded text-sm"
//                           value={field.options || ''}
//                           onChange={(e) => updateFormField(index, 'options', e.target.value)}
//                           placeholder="Option 1, Option 2, Option 3"
//                         />
//                       </div>
//                     )}
                    
//                     <div className="col-span-2">
//                       <label className="flex items-center">
//                         <input
//                           type="checkbox"
//                           className="mr-2"
//                           checked={field.required}
//                           onChange={(e) => updateFormField(index, 'required', e.target.checked)}
//                         />
//                         <span className="text-sm">Required Field</span>
//                       </label>
//                     </div>
//                   </div>
//                 </div>
//               ))}
              
//               <button
//                 type="button"
//                 onClick={addFormField}
//                 className="w-full py-2 mt-2 bg-blue-50 text-blue-600 rounded border border-blue-200 hover:bg-blue-100"
//               >
//                 + Add New Field
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
      
//       {/* Layout Options */}
//       <div className="border-t border-gray-200 pt-4">
//         <button
//           type="button"
//           className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//           onClick={() => setShowLayoutOptions(!showLayoutOptions)}
//         >
//           {showLayoutOptions ? 'Hide Layout Options' : 'Show Layout Options'}
//         </button>
        
//         {showLayoutOptions && (
//           <div className="space-y-4">
//             <h4 className="font-medium text-gray-800 mb-3">Layout Options</h4>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Layout Type
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.layoutType || 'side-by-side'}
//                 onChange={(e) => updateContent('layoutType', e.target.value)}
//               >
//                 <option value="side-by-side">Side by Side (Info | Form)</option>
//                 <option value="form-top">Form Above Info</option>
//                 <option value="info-top">Info Above Form</option>
//                 <option value="form-only">Form Only</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Border Radius
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.borderRadius || 'rounded-xl'}
//                 onChange={(e) => updateContent('borderRadius', e.target.value)}
//               >
//                 <option value="rounded-none">None</option>
//                 <option value="rounded">Small</option>
//                 <option value="rounded-md">Medium</option>
//                 <option value="rounded-lg">Large</option>
//                 <option value="rounded-xl">Extra Large</option>
//                 <option value="rounded-full">Full/Pill</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Shadow Style
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.shadowStyle || 'shadow-xl'}
//                 onChange={(e) => updateContent('shadowStyle', e.target.value)}
//               >
//                 <option value="shadow-none">None</option>
//                 <option value="shadow-sm">Small</option>
//                 <option value="shadow">Medium</option>
//                 <option value="shadow-md">Large</option>
//                 <option value="shadow-lg">Extra Large</option>
//                 <option value="shadow-xl">2XL</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Padding
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.padding || 'p-12'}
//                 onChange={(e) => updateContent('padding', e.target.value)}
//               >
//                 <option value="p-4">Small (16px)</option>
//                 <option value="p-6">Medium (24px)</option>
//                 <option value="p-8">Large (32px)</option>
//                 <option value="p-12">Extra Large (48px)</option>
//                 <option value="p-16">2XL (64px)</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center text-sm font-medium text-gray-700">
//                 <input
//                   type="checkbox"
//                   className="mr-2 h-4 w-4"
//                   checked={content?.showSocialIcons !== false}
//                   onChange={(e) => updateContent('showSocialIcons', e.target.checked)}
//                 />
//                 Show Social Media Icons
//               </label>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center text-sm font-medium text-gray-700">
//                 <input
//                   type="checkbox"
//                   className="mr-2 h-4 w-4"
//                   checked={content?.enableCaptcha === true}
//                   onChange={(e) => updateContent('enableCaptcha', e.target.checked)}
//                 />
//                 Enable CAPTCHA Protection
//               </label>
//               {content?.enableCaptcha && (
//                 <p className="text-xs text-gray-500 mt-1 ml-6">
//                   CAPTCHA will be enabled to protect against spam submissions.
//                 </p>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
      
//       {/* Advanced Settings */}
//       <div className="border-t border-gray-200 pt-4">
//         <button
//           type="button"
//           className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//           onClick={() => setShowAdvanced(!showAdvanced)}
//         >
//           {showAdvanced ? 'Hide Advanced Style Options' : 'Show Advanced Style Options'}
//         </button>
        
//         {showAdvanced && (
//           <div className="space-y-4">
//             <h4 className="font-medium text-gray-800 mb-3">Style Customization</h4>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Info Panel Background Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.backgroundColor || '#1A4B84'}
//                   onChange={(e) => updateContent('backgroundColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.backgroundColor || '#1A4B84'}
//                   onChange={(e) => updateContent('backgroundColor', e.target.value)}
//                   placeholder="#1A4B84"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Info Panel Text Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.textColor || '#ffffff'}
//                   onChange={(e) => updateContent('textColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.textColor || '#ffffff'}
//                   onChange={(e) => updateContent('textColor', e.target.value)}
//                   placeholder="#ffffff"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Form Background Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.formBackgroundColor || '#ffffff'}
//                   onChange={(e) => updateContent('formBackgroundColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.formBackgroundColor || '#ffffff'}
//                   onChange={(e) => updateContent('formBackgroundColor', e.target.value)}
//                   placeholder="#ffffff"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Button Background Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.buttonColor || '#1A4B84'}
//                   onChange={(e) => updateContent('buttonColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.buttonColor || '#1A4B84'}
//                   onChange={(e) => updateContent('buttonColor', e.target.value)}
//                   placeholder="#1A4B84"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Button Text Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.buttonTextColor || '#ffffff'}
//                   onChange={(e) => updateContent('buttonTextColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.buttonTextColor || '#ffffff'}
//                   onChange={(e) => updateContent('buttonTextColor', e.target.value)}
//                   placeholder="#ffffff"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Field Border Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.fieldBorderColor || '#e5e7eb'}
//                   onChange={(e) => updateContent('fieldBorderColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.fieldBorderColor || '#e5e7eb'}
//                   onChange={(e) => updateContent('fieldBorderColor', e.target.value)}
//                   placeholder="#e5e7eb"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Form Field Border Radius
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.fieldBorderRadius || 'rounded-lg'}
//                 onChange={(e) => updateContent('fieldBorderRadius', e.target.value)}
//               >
//                 <option value="rounded-none">None</option>
//                 <option value="rounded">Small</option>
//                 <option value="rounded-md">Medium</option>
//                 <option value="rounded-lg">Large</option>
//                 <option value="rounded-xl">Extra Large</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center text-sm font-medium text-gray-700">
//                 <input
//                   type="checkbox"
//                   className="mr-2 h-4 w-4"
//                   checked={content?.buttonFullWidth !== false}
//                   onChange={(e) => updateContent('buttonFullWidth', e.target.checked)}
//                 />
//                 Full Width Submit Button
//               </label>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Custom CSS (Advanced)
//               </label>
//               <textarea
//                 className="w-full p-2 border rounded font-mono text-sm"
//                 value={content?.customCss || ''}
//                 onChange={(e) => updateContent('customCss', e.target.value)}
//                 placeholder=".contact-form { /* custom styles */ }"
//                 rows="4"
//               />
//               <p className="text-xs text-gray-500 mt-1">
//                 Add custom CSS to further customize your form (for advanced users).
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
      
//       <div className="bg-blue-50 p-4 rounded-md mb-6">
//         <h4 className="text-blue-800 font-medium mb-2">Important Notes</h4>
//         <ul className="text-sm text-blue-700 space-y-1 list-disc list-inside">
//           <li>Form validation will automatically handle required fields</li>
//           <li>All form submissions will be sent to your specified email</li>
//           <li>Social media links will only appear if URLs are provided</li>
//           {content?.enableCaptcha && (
//             <li>CAPTCHA requires additional server-side configuration</li>
//           )}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default ContactFormSectionForm;
















// // src/components/admin/page-management/section-forms/ContactFormSectionForm.js
// import React, { useState } from 'react';

// const ContactFormSectionForm = ({ content, updateContent }) => {
//   const [showAdvanced, setShowAdvanced] = useState(false);
//   const [showFieldsConfig, setShowFieldsConfig] = useState(false);
//   const [showLayoutOptions, setShowLayoutOptions] = useState(false);

//   // Helper to update nested contact info
//   const updateContactInfo = (field, value) => {
//     // Get existing contactInfo or create default structure
//     const existingContactInfo = content?.contactInfo || {
//       phone: process.env.REACT_APP_COMPANY_PHONE_NUMBER || "+1 (833) 333-3101",
//       email: process.env.REACT_APP_COMPANY_EMAIL || "Info@bagbox.ca",
//       address: process.env.REACT_APP_COMPANY_ADDRESS || "102-1127 14th St W, North Vancouver, BC, V7P 1J9",
//       hours: {
//         weekday: "Monday - Friday: 9 AM - 5 PM",
//         weekend: "Saturday - Sunday: Closed"
//       },
//       socialMedia: {
//         facebook: "",
//         twitter: "",
//         instagram: "",
//         linkedin: ""
//       }
//     };
    
//     // Create a deep copy to avoid modifying the original object
//     const newContactInfo = JSON.parse(JSON.stringify(existingContactInfo));
    
//     if (field.includes('.')) {
//       // Handle nested field like 'hours.weekday' or 'socialMedia.facebook'
//       const [parent, child] = field.split('.');
      
//       // Ensure the parent object exists
//       if (!newContactInfo[parent]) {
//         newContactInfo[parent] = {};
//       }
      
//       newContactInfo[parent][child] = value;
//     } else {
//       // Handle top-level field
//       newContactInfo[field] = value;
//     }
    
//     // Update the content with the modified contactInfo
//     updateContent('contactInfo', newContactInfo);
//   };
  

//   // Helper to update form fields
//   const updateFormField = (index, property, value) => {
//     // Get existing formFields or use default
//     const formFields = Array.isArray(content?.formFields) ? 
//       [...content.formFields] : 
//       [...defaultFormFields];
    
//     // Create a new array with the updated field
//     const updatedFields = formFields.map((field, i) => {
//       if (i === index) {
//         return {
//           ...field,
//           [property]: value
//         };
//       }
//       return field;
//     });
    
//     // Update the content with the modified fields
//     updateContent('formFields', updatedFields);
//   };
  

//   // Move form field up/down
//   const moveFormField = (index, direction) => {
//     // Get existing formFields or use default
//     const formFields = Array.isArray(content?.formFields) ? 
//       [...content.formFields] : 
//       [...defaultFormFields];
    
//     // Create a copy of the array
//     const updatedFields = [...formFields];
    
//     // Move field up or down
//     if (direction === 'up' && index > 0) {
//       [updatedFields[index], updatedFields[index - 1]] = 
//       [updatedFields[index - 1], updatedFields[index]];
//     } else if (direction === 'down' && index < updatedFields.length - 1) {
//       [updatedFields[index], updatedFields[index + 1]] = 
//       [updatedFields[index + 1], updatedFields[index]];
//     }
    
//     // Update the content with the reordered fields
//     updateContent('formFields', updatedFields);
//   };

//   // Add new form field
//   const addFormField = () => {
//     // Get existing formFields or use default
//     const existingFields = Array.isArray(content?.formFields) ? 
//       [...content.formFields] : 
//       [...defaultFormFields];
    
//     // Add a new field with unique ID
//     const newField = {
//       id: `field_${Date.now()}`,
//       type: 'text',
//       label: 'New Field',
//       placeholder: 'Enter value',
//       required: false,
//       width: 'full'
//     };
    
//     // Update the content with the new field added
//     updateContent('formFields', [...existingFields, newField]);
//   };
  

//   // Remove form field
//   const removeFormField = (index) => {
//     // Get existing formFields or use default
//     const formFields = Array.isArray(content?.formFields) ? 
//       [...content.formFields] : 
//       [...defaultFormFields];
    
//     // Remove the field at the specified index
//     const updatedFields = formFields.filter((_, i) => i !== index);
    
//     // Update the content with the modified fields
//     updateContent('formFields', updatedFields);
//   };
  

//   // Default form fields if not defined
//   const defaultFormFields = [
//     {
//       id: 'name',
//       type: 'text',
//       label: 'Your Name',
//       placeholder: 'Your Name',
//       required: true,
//       width: 'half'
//     },
//     {
//       id: 'email',
//       type: 'email',
//       label: 'Your Email',
//       placeholder: 'Your Email',
//       required: true,
//       width: 'half'
//     },
//     {
//       id: 'phone',
//       type: 'tel',
//       label: 'Phone Number',
//       placeholder: 'Phone Number (Optional)',
//       required: false,
//       width: 'half'
//     },
//     {
//       id: 'company',
//       type: 'text',
//       label: 'Company Name',
//       placeholder: 'Company Name (Optional)',
//       required: false,
//       width: 'half'
//     },
//     {
//       id: 'message',
//       type: 'textarea',
//       label: 'Your Message',
//       placeholder: 'Your Message',
//       required: true,
//       width: 'full'
//     }
//   ];

//   return (
//     <div className="space-y-4">
//       <h3 className="text-lg font-medium">Contact Form Configuration</h3>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Form Section Title
//         </label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           value={content?.title || 'Send Us a Message'}
//           onChange={(e) => updateContent('title', e.target.value)}
//           placeholder="Send Us a Message"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Form Submit Button Text
//         </label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           value={content?.submitButtonText || 'Send Message'}
//           onChange={(e) => updateContent('submitButtonText', e.target.value)}
//           placeholder="Send Message"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Success Message
//         </label>
//         <textarea
//           className="w-full p-2 border rounded"
//           value={content?.successMessage || "Thank you for your message! We'll get back to you soon."}
//           onChange={(e) => updateContent('successMessage', e.target.value)}
//           placeholder="Thank you for your message! We'll get back to you soon."
//           rows="2"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Error Message
//         </label>
//         <textarea
//           className="w-full p-2 border rounded"
//           value={content?.errorMessage || "Sorry, there was an error sending your message. Please try again."}
//           onChange={(e) => updateContent('errorMessage', e.target.value)}
//           placeholder="Sorry, there was an error sending your message. Please try again."
//           rows="2"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="flex items-center text-sm font-medium text-gray-700">
//           <input
//             type="checkbox"
//             className="mr-2 h-4 w-4"
//             checked={content?.showContactInfo !== false}
//             onChange={(e) => updateContent('showContactInfo', e.target.checked)}
//           />
//           Show Contact Information Panel
//         </label>
//       </div>
      
//       {content?.showContactInfo !== false && (
//         <div className="border-t border-gray-200 pt-4 mb-4">
//           <h4 className="font-medium text-gray-800 mb-3">Contact Information</h4>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Phone Number
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.phone || process.env.REACT_APP_COMPANY_PHONE_NUMBER || '+1 (833) 333-3101'}
//               onChange={(e) => updateContactInfo('phone', e.target.value)}
//               placeholder="+1 (833) 333-3101"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Email Address
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.email || process.env.REACT_APP_COMPANY_EMAIL || 'Info@bagbox.ca'}
//               onChange={(e) => updateContactInfo('email', e.target.value)}
//               placeholder="Info@bagbox.ca"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Business Address
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.address || process.env.REACT_APP_COMPANY_ADDRESS || '102-1127 14th St W, North Vancouver, BC, V7P 1J9'}
//               onChange={(e) => updateContactInfo('address', e.target.value)}
//               placeholder="102-1127 14th St W, North Vancouver, BC, V7P 1J9"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Weekday Hours
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.hours?.weekday || 'Monday - Friday: 9 AM - 5 PM'}
//               onChange={(e) => updateContactInfo('hours.weekday', e.target.value)}
//               placeholder="Monday - Friday: 9 AM - 5 PM"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Weekend Hours
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.hours?.weekend || 'Saturday - Sunday: Closed'}
//               onChange={(e) => updateContactInfo('hours.weekend', e.target.value)}
//               placeholder="Saturday - Sunday: Closed"
//             />
//           </div>
          
//           <h4 className="font-medium text-gray-800 mb-3 mt-4">Social Media (Optional)</h4>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Facebook URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.facebook || ''}
//               onChange={(e) => updateContactInfo('socialMedia.facebook', e.target.value)}
//               placeholder="https://facebook.com/yourcompany"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Twitter URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.twitter || ''}
//               onChange={(e) => updateContactInfo('socialMedia.twitter', e.target.value)}
//               placeholder="https://twitter.com/yourcompany"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Instagram URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.instagram || ''}
//               onChange={(e) => updateContactInfo('socialMedia.instagram', e.target.value)}
//               placeholder="https://instagram.com/yourcompany"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               LinkedIn URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.linkedin || ''}
//               onChange={(e) => updateContactInfo('socialMedia.linkedin', e.target.value)}
//               placeholder="https://linkedin.com/company/yourcompany"
//             />
//           </div>
//         </div>
//       )}
      
//       {/* Form Fields Configuration */}
//       <div className="border-t border-gray-200 pt-4">
//         <button
//           type="button"
//           className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//           onClick={() => setShowFieldsConfig(!showFieldsConfig)}
//         >
//           {showFieldsConfig ? 'Hide Form Fields Configuration' : 'Show Form Fields Configuration'}
//         </button>
        
//         {showFieldsConfig && (
//           <div className="space-y-4">
//             <h4 className="font-medium text-gray-800 mb-3">Form Fields</h4>
            
//             <div className="bg-gray-50 p-4 rounded">
//               <p className="text-sm text-gray-700 mb-2">Configure the fields that appear in your contact form:</p>
              
//               {(content?.formFields || defaultFormFields).map((field, index) => (
//                 <div key={field.id} className="border rounded-lg p-4 mb-4 bg-white">
//                   <div className="flex justify-between items-center mb-3">
//                     <h5 className="font-medium">{field.label || `Field ${index + 1}`}</h5>
//                     <div className="flex space-x-2">
//                       <button 
//                         type="button"
//                         onClick={() => moveFormField(index, 'up')}
//                         disabled={index === 0}
//                         className={`text-gray-500 ${index === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-700'}`}
//                       >
//                         ↑
//                       </button>
//                       <button 
//                         type="button"
//                         onClick={() => moveFormField(index, 'down')}
//                         disabled={index === (content?.formFields || defaultFormFields).length - 1}
//                         className={`text-gray-500 ${index === (content?.formFields || defaultFormFields).length - 1 ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-700'}`}
//                       >
//                         ↓
//                       </button>
//                       <button 
//                         type="button"
//                         onClick={() => removeFormField(index)}
//                         className="text-red-500 hover:text-red-700"
//                       >
//                         ×
//                       </button>
//                     </div>
//                   </div>
                  
//                   <div className="grid grid-cols-2 gap-3">
//                     <div>
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Field Type
//                       </label>
//                       <select
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.type}
//                         onChange={(e) => updateFormField(index, 'type', e.target.value)}
//                       >
//                         <option value="text">Text</option>
//                         <option value="email">Email</option>
//                         <option value="tel">Phone</option>
//                         <option value="textarea">Text Area</option>
//                         <option value="select">Dropdown</option>
//                         <option value="checkbox">Checkbox</option>
//                       </select>
//                     </div>
                    
//                     <div>
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Field Width
//                       </label>
//                       <select
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.width}
//                         onChange={(e) => updateFormField(index, 'width', e.target.value)}
//                       >
//                         <option value="full">Full Width</option>
//                         <option value="half">Half Width</option>
//                         <option value="third">One Third</option>
//                       </select>
//                     </div>
                    
//                     <div className="col-span-2">
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Label
//                       </label>
//                       <input
//                         type="text"
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.label}
//                         onChange={(e) => updateFormField(index, 'label', e.target.value)}
//                         placeholder="Field Label"
//                       />
//                     </div>
                    
//                     <div className="col-span-2">
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Placeholder
//                       </label>
//                       <input
//                         type="text"
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.placeholder}
//                         onChange={(e) => updateFormField(index, 'placeholder', e.target.value)}
//                         placeholder="Field Placeholder"
//                       />
//                     </div>
                    
//                     {field.type === 'select' && (
//                       <div className="col-span-2">
//                         <label className="block text-xs font-medium text-gray-700 mb-1">
//                           Options (comma separated)
//                         </label>
//                         <input
//                           type="text"
//                           className="w-full p-2 border rounded text-sm"
//                           value={field.options || ''}
//                           onChange={(e) => updateFormField(index, 'options', e.target.value)}
//                           placeholder="Option 1, Option 2, Option 3"
//                         />
//                       </div>
//                     )}
                    
//                     <div className="col-span-2">
//                       <label className="flex items-center">
//                         <input
//                           type="checkbox"
//                           className="mr-2"
//                           checked={field.required}
//                           onChange={(e) => updateFormField(index, 'required', e.target.checked)}
//                         />
//                         <span className="text-sm">Required Field</span>
//                       </label>
//                     </div>
//                   </div>
//                 </div>
//               ))}
              
//               <button
//                 type="button"
//                 onClick={addFormField}
//                 className="w-full py-2 mt-2 bg-blue-50 text-blue-600 rounded border border-blue-200 hover:bg-blue-100"
//               >
//                 + Add New Field
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
      
//       {/* Layout Options */}
//       <div className="border-t border-gray-200 pt-4">
//         <button
//           type="button"
//           className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//           onClick={() => setShowLayoutOptions(!showLayoutOptions)}
//         >
//           {showLayoutOptions ? 'Hide Layout Options' : 'Show Layout Options'}
//         </button>
        
//         {showLayoutOptions && (
//           <div className="space-y-4">
//             <h4 className="font-medium text-gray-800 mb-3">Layout Options</h4>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Layout Type
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.layoutType || 'side-by-side'}
//                 onChange={(e) => updateContent('layoutType', e.target.value)}
//               >
//                 <option value="side-by-side">Side by Side (Info | Form)</option>
//                 <option value="form-top">Form Above Info</option>
//                 <option value="info-top">Info Above Form</option>
//                 <option value="form-only">Form Only</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Border Radius
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.borderRadius || 'rounded-xl'}
//                 onChange={(e) => updateContent('borderRadius', e.target.value)}
//               >
//                 <option value="rounded-none">None</option>
//                 <option value="rounded">Small</option>
//                 <option value="rounded-md">Medium</option>
//                 <option value="rounded-lg">Large</option>
//                 <option value="rounded-xl">Extra Large</option>
//                 <option value="rounded-full">Full/Pill</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Shadow Style
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.shadowStyle || 'shadow-xl'}
//                 onChange={(e) => updateContent('shadowStyle', e.target.value)}
//               >
//                 <option value="shadow-none">None</option>
//                 <option value="shadow-sm">Small</option>
//                 <option value="shadow">Medium</option>
//                 <option value="shadow-md">Large</option>
//                 <option value="shadow-lg">Extra Large</option>
//                 <option value="shadow-xl">2XL</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Padding
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.padding || 'p-12'}
//                 onChange={(e) => updateContent('padding', e.target.value)}
//               >
//                 <option value="p-4">Small (16px)</option>
//                 <option value="p-6">Medium (24px)</option>
//                 <option value="p-8">Large (32px)</option>
//                 <option value="p-12">Extra Large (48px)</option>
//                 <option value="p-16">2XL (64px)</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center text-sm font-medium text-gray-700">
//                 <input
//                   type="checkbox"
//                   className="mr-2 h-4 w-4"
//                   checked={content?.showSocialIcons !== false}
//                   onChange={(e) => updateContent('showSocialIcons', e.target.checked)}
//                 />
//                 Show Social Media Icons
//               </label>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center text-sm font-medium text-gray-700">
//                 <input
//                   type="checkbox"
//                   className="mr-2 h-4 w-4"
//                   checked={content?.enableCaptcha === true}
//                   onChange={(e) => updateContent('enableCaptcha', e.target.checked)}
//                 />
//                 Enable CAPTCHA Protection
//               </label>
//               {content?.enableCaptcha && (
//                 <p className="text-xs text-gray-500 mt-1 ml-6">
//                   CAPTCHA will be enabled to protect against spam submissions.
//                 </p>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
      
//       {/* Advanced Settings */}
//       <div className="border-t border-gray-200 pt-4">
//         <button
//           type="button"
//           className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//           onClick={() => setShowAdvanced(!showAdvanced)}
//         >
//           {showAdvanced ? 'Hide Advanced Style Options' : 'Show Advanced Style Options'}
//         </button>
        
//         {showAdvanced && (
//           <div className="space-y-4">
//             <h4 className="font-medium text-gray-800 mb-3">Style Customization</h4>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Info Panel Background Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.backgroundColor || '#1A4B84'}
//                   onChange={(e) => updateContent('backgroundColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.backgroundColor || '#1A4B84'}
//                   onChange={(e) => updateContent('backgroundColor', e.target.value)}
//                   placeholder="#1A4B84"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Info Panel Text Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.textColor || '#ffffff'}
//                   onChange={(e) => updateContent('textColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.textColor || '#ffffff'}
//                   onChange={(e) => updateContent('textColor', e.target.value)}
//                   placeholder="#ffffff"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Form Background Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.formBackgroundColor || '#ffffff'}
//                   onChange={(e) => updateContent('formBackgroundColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.formBackgroundColor || '#ffffff'}
//                   onChange={(e) => updateContent('formBackgroundColor', e.target.value)}
//                   placeholder="#ffffff"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Button Background Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.buttonColor || '#1A4B84'}
//                   onChange={(e) => updateContent('buttonColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.buttonColor || '#1A4B84'}
//                   onChange={(e) => updateContent('buttonColor', e.target.value)}
//                   placeholder="#1A4B84"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Button Text Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.buttonTextColor || '#ffffff'}
//                   onChange={(e) => updateContent('buttonTextColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.buttonTextColor || '#ffffff'}
//                   onChange={(e) => updateContent('buttonTextColor', e.target.value)}
//                   placeholder="#ffffff"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Field Border Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.fieldBorderColor || '#e5e7eb'}
//                   onChange={(e) => updateContent('fieldBorderColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.fieldBorderColor || '#e5e7eb'}
//                   onChange={(e) => updateContent('fieldBorderColor', e.target.value)}
//                   placeholder="#e5e7eb"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Form Field Border Radius
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.fieldBorderRadius || 'rounded-lg'}
//                 onChange={(e) => updateContent('fieldBorderRadius', e.target.value)}
//               >
//                 <option value="rounded-none">None</option>
//                 <option value="rounded">Small</option>
//                 <option value="rounded-md">Medium</option>
//                 <option value="rounded-lg">Large</option>
//                 <option value="rounded-xl">Extra Large</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center text-sm font-medium text-gray-700">
//                 <input
//                   type="checkbox"
//                   className="mr-2 h-4 w-4"
//                   checked={content?.buttonFullWidth !== false}
//                   onChange={(e) => updateContent('buttonFullWidth', e.target.checked)}
//                 />
//                 Full Width Submit Button
//               </label>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Custom CSS (Advanced)
//               </label>
//               <textarea
//                 className="w-full p-2 border rounded font-mono text-sm"
//                 value={content?.customCss || ''}
//                 onChange={(e) => updateContent('customCss', e.target.value)}
//                 placeholder=".contact-form { /* custom styles */ }"
//                 rows="4"
//               />
//               <p className="text-xs text-gray-500 mt-1">
//                 Add custom CSS to further customize your form (for advanced users).
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
      
//       <div className="bg-blue-50 p-4 rounded-md mb-6">
//         <h4 className="text-blue-800 font-medium mb-2">Important Notes</h4>
//         <ul className="text-sm text-blue-700 space-y-1 list-disc list-inside">
//           <li>Form validation will automatically handle required fields</li>
//           <li>All form submissions will be sent to your specified email</li>
//           <li>Social media links will only appear if URLs are provided</li>
//           {content?.enableCaptcha && (
//             <li>CAPTCHA requires additional server-side configuration</li>
//           )}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default ContactFormSectionForm;






















// // src/components/admin/page-management/section-forms/ContactFormSectionForm.js
// import React, { useState } from 'react';

// const ContactFormSectionForm = ({ content, updateContent }) => {
//   const [showAdvanced, setShowAdvanced] = useState(false);
//   const [showFieldsConfig, setShowFieldsConfig] = useState(false);
//   const [showLayoutOptions, setShowLayoutOptions] = useState(false);

//   // Helper to update nested contact info
//   const updateContactInfo = (field, value) => {
//     const newContactInfo = { 
//       ...(content?.contactInfo || {
//         phone: process.env.REACT_APP_COMPANY_PHONE_NUMBER || "+1 (833) 333-3101",
//         email: process.env.REACT_APP_COMPANY_EMAIL || "Info@bagbox.ca",
//         address: process.env.REACT_APP_COMPANY_ADDRESS || "102-1127 14th St W, North Vancouver, BC, V7P 1J9",
//         hours: {
//           weekday: "Monday - Friday: 9 AM - 5 PM",
//           weekend: "Saturday - Sunday: Closed"
//         },
//         socialMedia: {
//           facebook: "",
//           twitter: "",
//           instagram: "",
//           linkedin: ""
//         }
//       })
//     };
    
//     if (field.includes('.')) {
//       // Handle nested field like 'hours.weekday'
//       const [parent, child] = field.split('.');
//       newContactInfo[parent] = {
//         ...newContactInfo[parent],
//         [child]: value
//       };
//     } else {
//       newContactInfo[field] = value;
//     }
    
//     updateContent('contactInfo', newContactInfo);
//   };

//   // Helper to update form fields
//   const updateFormField = (index, property, value) => {
//     const formFields = [...(content?.formFields || defaultFormFields)];
//     formFields[index] = {
//       ...formFields[index],
//       [property]: value
//     };
//     updateContent('formFields', formFields);
//   };

//   // Move form field up/down
//   const moveFormField = (index, direction) => {
//     const formFields = [...(content?.formFields || defaultFormFields)];
//     if (direction === 'up' && index > 0) {
//       [formFields[index], formFields[index - 1]] = [formFields[index - 1], formFields[index]];
//     } else if (direction === 'down' && index < formFields.length - 1) {
//       [formFields[index], formFields[index + 1]] = [formFields[index + 1], formFields[index]];
//     }
//     updateContent('formFields', formFields);
//   };

//   // Add new form field
//   const addFormField = () => {
//     const formFields = [...(content?.formFields || defaultFormFields)];
//     formFields.push({
//       id: `field_${Date.now()}`,
//       type: 'text',
//       label: 'New Field',
//       placeholder: 'Enter value',
//       required: false,
//       width: 'full'
//     });
//     updateContent('formFields', formFields);
//   };

//   // Remove form field
//   const removeFormField = (index) => {
//     const formFields = [...(content?.formFields || defaultFormFields)];
//     formFields.splice(index, 1);
//     updateContent('formFields', formFields);
//   };

//   // Default form fields if not defined
//   const defaultFormFields = [
//     {
//       id: 'name',
//       type: 'text',
//       label: 'Your Name',
//       placeholder: 'Your Name',
//       required: true,
//       width: 'half'
//     },
//     {
//       id: 'email',
//       type: 'email',
//       label: 'Your Email',
//       placeholder: 'Your Email',
//       required: true,
//       width: 'half'
//     },
//     {
//       id: 'phone',
//       type: 'tel',
//       label: 'Phone Number',
//       placeholder: 'Phone Number (Optional)',
//       required: false,
//       width: 'half'
//     },
//     {
//       id: 'company',
//       type: 'text',
//       label: 'Company Name',
//       placeholder: 'Company Name (Optional)',
//       required: false,
//       width: 'half'
//     },
//     {
//       id: 'message',
//       type: 'textarea',
//       label: 'Your Message',
//       placeholder: 'Your Message',
//       required: true,
//       width: 'full'
//     }
//   ];

//   return (
//     <div className="space-y-4">
//       <h3 className="text-lg font-medium">Contact Form Configuration</h3>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Form Section Title
//         </label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           value={content?.title || 'Send Us a Message'}
//           onChange={(e) => updateContent('title', e.target.value)}
//           placeholder="Send Us a Message"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Form Submit Button Text
//         </label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           value={content?.submitButtonText || 'Send Message'}
//           onChange={(e) => updateContent('submitButtonText', e.target.value)}
//           placeholder="Send Message"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Success Message
//         </label>
//         <textarea
//           className="w-full p-2 border rounded"
//           value={content?.successMessage || "Thank you for your message! We'll get back to you soon."}
//           onChange={(e) => updateContent('successMessage', e.target.value)}
//           placeholder="Thank you for your message! We'll get back to you soon."
//           rows="2"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Error Message
//         </label>
//         <textarea
//           className="w-full p-2 border rounded"
//           value={content?.errorMessage || "Sorry, there was an error sending your message. Please try again."}
//           onChange={(e) => updateContent('errorMessage', e.target.value)}
//           placeholder="Sorry, there was an error sending your message. Please try again."
//           rows="2"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="flex items-center text-sm font-medium text-gray-700">
//           <input
//             type="checkbox"
//             className="mr-2 h-4 w-4"
//             checked={content?.showContactInfo !== false}
//             onChange={(e) => updateContent('showContactInfo', e.target.checked)}
//           />
//           Show Contact Information Panel
//         </label>
//       </div>
      
//       {content?.showContactInfo !== false && (
//         <div className="border-t border-gray-200 pt-4 mb-4">
//           <h4 className="font-medium text-gray-800 mb-3">Contact Information</h4>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Phone Number
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.phone || process.env.REACT_APP_COMPANY_PHONE_NUMBER || '+1 (833) 333-3101'}
//               onChange={(e) => updateContactInfo('phone', e.target.value)}
//               placeholder="+1 (833) 333-3101"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Email Address
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.email || process.env.REACT_APP_COMPANY_EMAIL || 'Info@bagbox.ca'}
//               onChange={(e) => updateContactInfo('email', e.target.value)}
//               placeholder="Info@bagbox.ca"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Business Address
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.address || process.env.REACT_APP_COMPANY_ADDRESS || '102-1127 14th St W, North Vancouver, BC, V7P 1J9'}
//               onChange={(e) => updateContactInfo('address', e.target.value)}
//               placeholder="102-1127 14th St W, North Vancouver, BC, V7P 1J9"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Weekday Hours
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.hours?.weekday || 'Monday - Friday: 9 AM - 5 PM'}
//               onChange={(e) => updateContactInfo('hours.weekday', e.target.value)}
//               placeholder="Monday - Friday: 9 AM - 5 PM"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Weekend Hours
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.hours?.weekend || 'Saturday - Sunday: Closed'}
//               onChange={(e) => updateContactInfo('hours.weekend', e.target.value)}
//               placeholder="Saturday - Sunday: Closed"
//             />
//           </div>
          
//           <h4 className="font-medium text-gray-800 mb-3 mt-4">Social Media (Optional)</h4>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Facebook URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.facebook || ''}
//               onChange={(e) => updateContactInfo('socialMedia.facebook', e.target.value)}
//               placeholder="https://facebook.com/yourcompany"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Twitter URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.twitter || ''}
//               onChange={(e) => updateContactInfo('socialMedia.twitter', e.target.value)}
//               placeholder="https://twitter.com/yourcompany"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Instagram URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.instagram || ''}
//               onChange={(e) => updateContactInfo('socialMedia.instagram', e.target.value)}
//               placeholder="https://instagram.com/yourcompany"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               LinkedIn URL
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.socialMedia?.linkedin || ''}
//               onChange={(e) => updateContactInfo('socialMedia.linkedin', e.target.value)}
//               placeholder="https://linkedin.com/company/yourcompany"
//             />
//           </div>
//         </div>
//       )}
      
//       {/* Form Fields Configuration */}
//       <div className="border-t border-gray-200 pt-4">
//         <button
//           type="button"
//           className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//           onClick={() => setShowFieldsConfig(!showFieldsConfig)}
//         >
//           {showFieldsConfig ? 'Hide Form Fields Configuration' : 'Show Form Fields Configuration'}
//         </button>
        
//         {showFieldsConfig && (
//           <div className="space-y-4">
//             <h4 className="font-medium text-gray-800 mb-3">Form Fields</h4>
            
//             <div className="bg-gray-50 p-4 rounded">
//               <p className="text-sm text-gray-700 mb-2">Configure the fields that appear in your contact form:</p>
              
//               {(content?.formFields || defaultFormFields).map((field, index) => (
//                 <div key={field.id} className="border rounded-lg p-4 mb-4 bg-white">
//                   <div className="flex justify-between items-center mb-3">
//                     <h5 className="font-medium">{field.label || `Field ${index + 1}`}</h5>
//                     <div className="flex space-x-2">
//                       <button 
//                         type="button"
//                         onClick={() => moveFormField(index, 'up')}
//                         disabled={index === 0}
//                         className={`text-gray-500 ${index === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-700'}`}
//                       >
//                         ↑
//                       </button>
//                       <button 
//                         type="button"
//                         onClick={() => moveFormField(index, 'down')}
//                         disabled={index === (content?.formFields || defaultFormFields).length - 1}
//                         className={`text-gray-500 ${index === (content?.formFields || defaultFormFields).length - 1 ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-700'}`}
//                       >
//                         ↓
//                       </button>
//                       <button 
//                         type="button"
//                         onClick={() => removeFormField(index)}
//                         className="text-red-500 hover:text-red-700"
//                       >
//                         ×
//                       </button>
//                     </div>
//                   </div>
                  
//                   <div className="grid grid-cols-2 gap-3">
//                     <div>
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Field Type
//                       </label>
//                       <select
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.type}
//                         onChange={(e) => updateFormField(index, 'type', e.target.value)}
//                       >
//                         <option value="text">Text</option>
//                         <option value="email">Email</option>
//                         <option value="tel">Phone</option>
//                         <option value="textarea">Text Area</option>
//                         <option value="select">Dropdown</option>
//                         <option value="checkbox">Checkbox</option>
//                       </select>
//                     </div>
                    
//                     <div>
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Field Width
//                       </label>
//                       <select
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.width}
//                         onChange={(e) => updateFormField(index, 'width', e.target.value)}
//                       >
//                         <option value="full">Full Width</option>
//                         <option value="half">Half Width</option>
//                         <option value="third">One Third</option>
//                       </select>
//                     </div>
                    
//                     <div className="col-span-2">
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Label
//                       </label>
//                       <input
//                         type="text"
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.label}
//                         onChange={(e) => updateFormField(index, 'label', e.target.value)}
//                         placeholder="Field Label"
//                       />
//                     </div>
                    
//                     <div className="col-span-2">
//                       <label className="block text-xs font-medium text-gray-700 mb-1">
//                         Placeholder
//                       </label>
//                       <input
//                         type="text"
//                         className="w-full p-2 border rounded text-sm"
//                         value={field.placeholder}
//                         onChange={(e) => updateFormField(index, 'placeholder', e.target.value)}
//                         placeholder="Field Placeholder"
//                       />
//                     </div>
                    
//                     {field.type === 'select' && (
//                       <div className="col-span-2">
//                         <label className="block text-xs font-medium text-gray-700 mb-1">
//                           Options (comma separated)
//                         </label>
//                         <input
//                           type="text"
//                           className="w-full p-2 border rounded text-sm"
//                           value={field.options || ''}
//                           onChange={(e) => updateFormField(index, 'options', e.target.value)}
//                           placeholder="Option 1, Option 2, Option 3"
//                         />
//                       </div>
//                     )}
                    
//                     <div className="col-span-2">
//                       <label className="flex items-center">
//                         <input
//                           type="checkbox"
//                           className="mr-2"
//                           checked={field.required}
//                           onChange={(e) => updateFormField(index, 'required', e.target.checked)}
//                         />
//                         <span className="text-sm">Required Field</span>
//                       </label>
//                     </div>
//                   </div>
//                 </div>
//               ))}
              
//               <button
//                 type="button"
//                 onClick={addFormField}
//                 className="w-full py-2 mt-2 bg-blue-50 text-blue-600 rounded border border-blue-200 hover:bg-blue-100"
//               >
//                 + Add New Field
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
      
//       {/* Layout Options */}
//       <div className="border-t border-gray-200 pt-4">
//         <button
//           type="button"
//           className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//           onClick={() => setShowLayoutOptions(!showLayoutOptions)}
//         >
//           {showLayoutOptions ? 'Hide Layout Options' : 'Show Layout Options'}
//         </button>
        
//         {showLayoutOptions && (
//           <div className="space-y-4">
//             <h4 className="font-medium text-gray-800 mb-3">Layout Options</h4>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Layout Type
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.layoutType || 'side-by-side'}
//                 onChange={(e) => updateContent('layoutType', e.target.value)}
//               >
//                 <option value="side-by-side">Side by Side (Info | Form)</option>
//                 <option value="form-top">Form Above Info</option>
//                 <option value="info-top">Info Above Form</option>
//                 <option value="form-only">Form Only</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Border Radius
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.borderRadius || 'rounded-xl'}
//                 onChange={(e) => updateContent('borderRadius', e.target.value)}
//               >
//                 <option value="rounded-none">None</option>
//                 <option value="rounded">Small</option>
//                 <option value="rounded-md">Medium</option>
//                 <option value="rounded-lg">Large</option>
//                 <option value="rounded-xl">Extra Large</option>
//                 <option value="rounded-full">Full/Pill</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Shadow Style
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.shadowStyle || 'shadow-xl'}
//                 onChange={(e) => updateContent('shadowStyle', e.target.value)}
//               >
//                 <option value="shadow-none">None</option>
//                 <option value="shadow-sm">Small</option>
//                 <option value="shadow">Medium</option>
//                 <option value="shadow-md">Large</option>
//                 <option value="shadow-lg">Extra Large</option>
//                 <option value="shadow-xl">2XL</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Padding
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.padding || 'p-12'}
//                 onChange={(e) => updateContent('padding', e.target.value)}
//               >
//                 <option value="p-4">Small (16px)</option>
//                 <option value="p-6">Medium (24px)</option>
//                 <option value="p-8">Large (32px)</option>
//                 <option value="p-12">Extra Large (48px)</option>
//                 <option value="p-16">2XL (64px)</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center text-sm font-medium text-gray-700">
//                 <input
//                   type="checkbox"
//                   className="mr-2 h-4 w-4"
//                   checked={content?.showSocialIcons !== false}
//                   onChange={(e) => updateContent('showSocialIcons', e.target.checked)}
//                 />
//                 Show Social Media Icons
//               </label>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center text-sm font-medium text-gray-700">
//                 <input
//                   type="checkbox"
//                   className="mr-2 h-4 w-4"
//                   checked={content?.enableCaptcha === true}
//                   onChange={(e) => updateContent('enableCaptcha', e.target.checked)}
//                 />
//                 Enable CAPTCHA Protection
//               </label>
//               {content?.enableCaptcha && (
//                 <p className="text-xs text-gray-500 mt-1 ml-6">
//                   CAPTCHA will be enabled to protect against spam submissions.
//                 </p>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
      
//       {/* Advanced Settings */}
//       <div className="border-t border-gray-200 pt-4">
//         <button
//           type="button"
//           className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//           onClick={() => setShowAdvanced(!showAdvanced)}
//         >
//           {showAdvanced ? 'Hide Advanced Style Options' : 'Show Advanced Style Options'}
//         </button>
        
//         {showAdvanced && (
//           <div className="space-y-4">
//             <h4 className="font-medium text-gray-800 mb-3">Style Customization</h4>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Info Panel Background Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.backgroundColor || '#1A4B84'}
//                   onChange={(e) => updateContent('backgroundColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.backgroundColor || '#1A4B84'}
//                   onChange={(e) => updateContent('backgroundColor', e.target.value)}
//                   placeholder="#1A4B84"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Info Panel Text Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.textColor || '#ffffff'}
//                   onChange={(e) => updateContent('textColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.textColor || '#ffffff'}
//                   onChange={(e) => updateContent('textColor', e.target.value)}
//                   placeholder="#ffffff"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Form Background Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.formBackgroundColor || '#ffffff'}
//                   onChange={(e) => updateContent('formBackgroundColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.formBackgroundColor || '#ffffff'}
//                   onChange={(e) => updateContent('formBackgroundColor', e.target.value)}
//                   placeholder="#ffffff"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Button Background Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.buttonColor || '#1A4B84'}
//                   onChange={(e) => updateContent('buttonColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.buttonColor || '#1A4B84'}
//                   onChange={(e) => updateContent('buttonColor', e.target.value)}
//                   placeholder="#1A4B84"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Button Text Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.buttonTextColor || '#ffffff'}
//                   onChange={(e) => updateContent('buttonTextColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.buttonTextColor || '#ffffff'}
//                   onChange={(e) => updateContent('buttonTextColor', e.target.value)}
//                   placeholder="#ffffff"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Field Border Color
//               </label>
//               <div className="flex items-center">
//                 <input
//                   type="color"
//                   className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                   value={content?.fieldBorderColor || '#e5e7eb'}
//                   onChange={(e) => updateContent('fieldBorderColor', e.target.value)}
//                 />
//                 <input
//                   type="text"
//                   className="flex-1 p-2 border rounded"
//                   value={content?.fieldBorderColor || '#e5e7eb'}
//                   onChange={(e) => updateContent('fieldBorderColor', e.target.value)}
//                   placeholder="#e5e7eb"
//                 />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Form Field Border Radius
//               </label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.fieldBorderRadius || 'rounded-lg'}
//                 onChange={(e) => updateContent('fieldBorderRadius', e.target.value)}
//               >
//                 <option value="rounded-none">None</option>
//                 <option value="rounded">Small</option>
//                 <option value="rounded-md">Medium</option>
//                 <option value="rounded-lg">Large</option>
//                 <option value="rounded-xl">Extra Large</option>
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center text-sm font-medium text-gray-700">
//                 <input
//                   type="checkbox"
//                   className="mr-2 h-4 w-4"
//                   checked={content?.buttonFullWidth !== false}
//                   onChange={(e) => updateContent('buttonFullWidth', e.target.checked)}
//                 />
//                 Full Width Submit Button
//               </label>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Custom CSS (Advanced)
//               </label>
//               <textarea
//                 className="w-full p-2 border rounded font-mono text-sm"
//                 value={content?.customCss || ''}
//                 onChange={(e) => updateContent('customCss', e.target.value)}
//                 placeholder=".contact-form { /* custom styles */ }"
//                 rows="4"
//               />
//               <p className="text-xs text-gray-500 mt-1">
//                 Add custom CSS to further customize your form (for advanced users).
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
      
//       <div className="bg-blue-50 p-4 rounded-md mb-6">
//         <h4 className="text-blue-800 font-medium mb-2">Important Notes</h4>
//         <ul className="text-sm text-blue-700 space-y-1 list-disc list-inside">
//           <li>Make sure your contact form endpoint is set up in the backend</li>
//           <li>Form validation will automatically handle required fields</li>
//           <li>All form submissions will be sent to your specified email</li>
//           <li>Social media links will only appear if URLs are provided</li>
//           {content?.enableCaptcha && (
//             <li>CAPTCHA requires additional server-side configuration</li>
//           )}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default ContactFormSectionForm;




















// // src/components/admin/page-management/section-forms/ContactFormSectionForm.js
// import React, { useState } from 'react';

// const ContactFormSectionForm = ({ content, updateContent }) => {
//   const [showAdvanced, setShowAdvanced] = useState(false);

//   // Helper to update nested contact info
//   const updateContactInfo = (field, value) => {
//     const newContactInfo = { 
//       ...(content?.contactInfo || {
//         phone: "+1 (833) 333-3101",
//         email: "Info@bagbox.ca",
//         hours: {
//           weekday: "Monday - Friday: 9 AM - 5 PM",
//           weekend: "Saturday - Sunday: Closed"
//         }
//       })
//     };
    
//     if (field.includes('.')) {
//       // Handle nested field like 'hours.weekday'
//       const [parent, child] = field.split('.');
//       newContactInfo[parent] = {
//         ...newContactInfo[parent],
//         [child]: value
//       };
//     } else {
//       newContactInfo[field] = value;
//     }
    
//     updateContent('contactInfo', newContactInfo);
//   };

//   return (
//     <div className="space-y-4">
//       <h3 className="text-lg font-medium">Contact Form Configuration</h3>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Form Section Title
//         </label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           value={content?.title || 'Send Us a Message'}
//           onChange={(e) => updateContent('title', e.target.value)}
//           placeholder="Send Us a Message"
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="flex items-center text-sm font-medium text-gray-700">
//           <input
//             type="checkbox"
//             className="mr-2 h-4 w-4"
//             checked={content?.showContactInfo !== false}
//             onChange={(e) => updateContent('showContactInfo', e.target.checked)}
//           />
//           Show Contact Information Panel
//         </label>
//       </div>
      
//       {content?.showContactInfo !== false && (
//         <div className="border-t border-gray-200 pt-4 mb-4">
//           <h4 className="font-medium text-gray-800 mb-3">Contact Information</h4>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Phone Number
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.phone || '+1 (833) 333-3101'}
//               onChange={(e) => updateContactInfo('phone', e.target.value)}
//               placeholder="+1 (833) 333-3101"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Email Address
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.email || 'Info@bagbox.ca'}
//               onChange={(e) => updateContactInfo('email', e.target.value)}
//               placeholder="Info@bagbox.ca"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Weekday Hours
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.hours?.weekday || 'Monday - Friday: 9 AM - 5 PM'}
//               onChange={(e) => updateContactInfo('hours.weekday', e.target.value)}
//               placeholder="Monday - Friday: 9 AM - 5 PM"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Weekend Hours
//             </label>
//             <input
//               type="text"
//               className="w-full p-2 border rounded"
//               value={content?.contactInfo?.hours?.weekend || 'Saturday - Sunday: Closed'}
//               onChange={(e) => updateContactInfo('hours.weekend', e.target.value)}
//               placeholder="Saturday - Sunday: Closed"
//             />
//           </div>
//         </div>
//       )}
      
//       <button
//         type="button"
//         className="text-sm text-blue-600 hover:text-blue-800 mb-4"
//         onClick={() => setShowAdvanced(!showAdvanced)}
//       >
//         {showAdvanced ? 'Hide Advanced Options' : 'Show Advanced Options'}
//       </button>
      
//       {showAdvanced && (
//         <div className="border-t border-gray-200 pt-4">
//           <h4 className="font-medium text-gray-800 mb-3">Style Customization</h4>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Background Color (Info Panel)
//             </label>
//             <div className="flex items-center">
//               <input
//                 type="color"
//                 className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                 value={content?.backgroundColor || '#1A4B84'}
//                 onChange={(e) => updateContent('backgroundColor', e.target.value)}
//               />
//               <input
//                 type="text"
//                 className="flex-1 p-2 border rounded"
//                 value={content?.backgroundColor || '#1A4B84'}
//                 onChange={(e) => updateContent('backgroundColor', e.target.value)}
//                 placeholder="#1A4B84"
//               />
//             </div>
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Text Color (Info Panel)
//             </label>
//             <div className="flex items-center">
//               <input
//                 type="color"
//                 className="h-10 w-10 p-0 border border-gray-300 rounded mr-2"
//                 value={content?.textColor || '#ffffff'}
//                 onChange={(e) => updateContent('textColor', e.target.value)}
//               />
//               <input
//                 type="text"
//                 className="flex-1 p-2 border rounded"
//                 value={content?.textColor || '#ffffff'}
//                 onChange={(e) => updateContent('textColor', e.target.value)}
//                 placeholder="#ffffff"
//               />
//             </div>
//           </div>
//         </div>
//       )}
      
//       <div className="bg-blue-50 p-4 rounded-md mb-6">
//         <h4 className="text-blue-800 font-medium mb-2">Important Notes</h4>
//         <ul className="text-sm text-blue-700 space-y-1 list-disc list-inside">
//           <li>Make sure your contact form endpoint is set up in the backend</li>
//           <li>Form validation is built-in and handles required fields</li>
//           <li>Success/error messages will display automatically after submission</li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default ContactFormSectionForm;